<template>
    <v-layout column>
        <v-toolbar color="primary">
            <v-btn icon v-if="step == 2" @click="step=1">
                <v-icon style="color: white;" class="material-icons">arrow_back</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title style="color:white;">
                Solicitação de convênio
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-stepper v-model="step" class="mt-4" style="box-shadow: none;">
          <v-stepper-items style="box-shadow: none;">
            <v-stepper-content step="1" style="box-shadow: none;" class="ma-0 pa-0">
              <v-alert
                v-if="alert"
                type="success"
                class="pa-2"
                :value="true"
              >
                {{ aceito ? 'Solicitação aceita com sucesso' : 'Solicitação rejeitada com sucesso' }}
              </v-alert>
                <v-list-tile class="mt-3" avatar v-for="(item, i) in solicitacoes_convenio"
                        :key="i" style="height: 120px;">
                    <v-list-tile-content class="mt-4" style="height: 180px;">
                        <v-list-tile-title>Nome: <b>{{item.convenio.nome_convenio}}</b></v-list-tile-title>
                        <v-list-tile-sub-title>Codígo: <b>{{item.convenio.codigo}}</b></v-list-tile-sub-title>
                        <v-list-tile-sub-title>Número de conveniados: <b>{{item.convenio.cpfs_permitidos.length}}</b></v-list-tile-sub-title>
                        <v-list-tile-sub-title>Data de solicitação: <b>{{item.data_solicitacao | formatDate('DD/MM/YYYY')}}</b></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="item.rede" class="text-xs-center mt-1">
                          <v-icon>ac_unit</v-icon>
                          {{item.rede.nome}}
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title v-else class="text-xs-center mt-1">
                          <v-icon>local_gas_station</v-icon>
                          {{posto.nome_fantasia}}
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-btn icon ripple @click="visualizarSolicitacao(item)">
                            <v-icon color="primary">visibility</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
            </v-stepper-content>
            <v-stepper-content step="2" style="box-shadow: none;" class="ma-0 pa-0" v-if="solicitacaoSelecionada">
                <v-container>
                    <h1 v-if="solicitacaoSelecionada.rede"><v-icon>ac_unit</v-icon> {{solicitacaoSelecionada.rede.nome}}</h1>
                    <h1 v-else><v-icon>local_gas_station</v-icon> {{posto.nome_fantasia}}</h1>
                    <h2 class="text-xs-center">{{solicitacaoSelecionada.convenio.nome_convenio}}</h2>
                    <h4 class="mt-1 subheading">Codígo: <b>{{solicitacaoSelecionada.convenio.codigo}}</b></h4>
                    <h4 class="subheading">Número de conveniados: <b>{{solicitacaoSelecionada.convenio.cpfs_permitidos.length}}</b></h4>
                    <h4 class="subheading">Solicitado: <b>{{solicitacaoSelecionada.data_solicitacao | formatDate('DD/MM/YYYY')}}</b></h4>
                    <template v-if="solicitacaoSelecionada.convenio.instituicao_representante">
                      <div>
                        <h4 class="subheading">{{solicitacaoSelecionada.convenio.instituicao_representante.tipo}} representante: <b>{{ solicitacaoSelecionada.convenio.instituicao_representante.nome }}</b></h4>
                        <h4 class="subheading">CNPJ: <b>{{ solicitacaoSelecionada.convenio.instituicao_representante.cnpj }}</b></h4>
                        <h4 class="subheading">Telefone: <b>{{ solicitacaoSelecionada.convenio.instituicao_representante.telefone }}</b></h4>
                      </div>
                    </template>
                    <v-layout row wrap justify-space-between class="mt-3" v-if="!resposta || solicitacaoSelecionada.status !== null">
                      <v-btn small color="error" @click="enviarResposta(false)">Rejeitar</v-btn>
                      <v-btn small color="success" @click="resposta = true">Aceitar</v-btn>
                    </v-layout>
                    <v-layout column v-if="resposta" class="mt-3">
                      <v-text-field
                          label="Percentual do desconto"
                          hide-details
                          required
                          v-model="desconto"
                          suffix="%"
                      ></v-text-field>
                    <v-btn :disabled="this.desconto <= 0" class="mt-4" color="success" @click="enviarResposta(true)">Confirmar</v-btn>
                  </v-layout>
                </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
    </v-layout>
</template>

<script>

export default {
  data () {
    return {
      step: 1,
      solicitacoes_convenio: [],
      solicitacaoSelecionada: null,
      resposta: false,
      desconto: 0,
      alert: false,
      aceito: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    pegarSolicitacoes () {
      this.$store.dispatch('solicitacoesConvenio').then(value => {
        this.solicitacoes_convenio = value
      })
    },
    visualizarSolicitacao (solicitacao) {
      this.solicitacaoSelecionada = solicitacao
      this.step++
    },
    enviarResposta (resposta) {
      if (this.resposta) {
        this.$store.dispatch('aceitarSolicitacao', {
          status: resposta,
          id: this.solicitacaoSelecionada.id,
          desconto: this.desconto
        }).then(() => {
          this.pegarSolicitacoes()
          this.$emit('carregar')
          this.step--
          this.desconto = 0
          this.resposta = false
          this.alert = true
          this.aceito = true
          let interval = setInterval(() => {
            this.alert = false
            clearInterval(interval)
          }, 5000)
        })
      } else {
        this.$store.dispatch('aceitarSolicitacao', {
          status: this.resposta,
          id: this.solicitacaoSelecionada.id
        }).then(() => {
          this.pegarSolicitacoes()
          this.$emit('carregar')
          this.step--
          this.resposta = false
          this.aceito = false
          this.alert = true
          let interval = setInterval(() => {
            this.alert = false
            clearInterval(interval)
          }, 5000)
        })
      }
    }
  },
  beforeMount () {
    this.pegarSolicitacoes()
  }
}
</script>
